import { Component, Inject } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
// A confirmation dialog requiring the user to type 'confirm'.
@Component({
    selector: 'ca-input-confirmation-dialog',
    templateUrl: './input-confirmation-dialog.component.html',
    styleUrls: ['./input-confirmation-dialog.component.scss'],
    standalone: false
})
export class InputConfirmationDialogComponent {
  title = 'Are you sure?';
  body = '';
  inputInstruction = 'Please type confirm into the box below.';
  confirm = 'Yes';
  cancel = 'Cancel';
  confirmColor = 'primary';
  confirmationControl: UntypedFormControl;

  constructor(
    private ref: MatDialogRef<InputConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.confirmationControl = new UntypedFormControl('');
    for (const key in data) {
      if (data[key]) {
        this[key] = data[key];
      }
    }
  }

  confirmAction() {
    this.ref.close(true);
  }

  cancelAction() {
    this.ref.close();
  }
}
